import dayjs from 'dayjs';

import type { PointDistributionData } from './types';

export const POINT_DISTRIBUTION_TABLE_COLUMNS = [
  {
    title: '建立時間',
    dataIndex: 'createdTime',
    render: (value: number) => dayjs(value).format('YYYY/MM/DD HH:mm:ss'),
  },
  {
    title: '服務',
    dataIndex: 'service',
  },
  {
    title: '會員',
    dataIndex: 'member',
  },
  {
    title: '手機號碼',
    dataIndex: 'phoneNumber',
  },
  {
    title: '交易名目',
    dataIndex: 'transactionName',
  },
  {
    title: '交易點數',
    dataIndex: 'transactionPoints',
  },
  {
    title: '剩餘點數',
    dataIndex: 'remainingPoints',
  },
  {
    title: '更新時間',
    dataIndex: 'updatedTime',
    render: (value: number) => dayjs(value).format('YYYY/MM/DD HH:mm:ss'),
  },
];

// TODO: 從這以下為假資料，記得改成真實資料後刪除
export const DUMMY_SERVICE_OPTIONS = [
  {
    label: '育樂活動',
    value: '育樂活動',
  },
  {
    label: '清潔服務',
    value: '清潔服務',
  },
];

export const DUMMY_POINT_DISTRIBUTIONS: PointDistributionData[] = [
  {
    _id: '001',
    createdTime: 1744076557000,
    service: '清潔服務',
    member: '鄭智薰',
    phoneNumber: '0987666777',
    transactionName: '清潔服務扣點',
    transactionPoints: 150,
    remainingPoints: 270,
    updatedTime: 1744157873000,
  },
  {
    _id: '002',
    createdTime: 1744076558000,
    service: '育樂活動',
    member: '金秀賢',
    phoneNumber: '0912345678',
    transactionName: '瑜珈課程扣點',
    transactionPoints: 200,
    remainingPoints: 800,
    updatedTime: 1744157874000,
  },
  {
    _id: '005',
    createdTime: 1744076561000,
    service: '清潔服務',
    member: '朴敘俊',
    phoneNumber: '0945678901',
    transactionName: '清潔服務扣點',
    transactionPoints: 180,
    remainingPoints: 520,
    updatedTime: 1744157881000,
  },
  {
    _id: '006',
    createdTime: 1744076562000,
    service: '育樂活動',
    member: '李鍾碩',
    phoneNumber: '0956789012',
    transactionName: '健身課程扣點',
    transactionPoints: 250,
    remainingPoints: 550,
    updatedTime: 1744157882000,
  },
  {
    _id: '008',
    createdTime: 1744076564000,
    service: '育樂活動',
    member: '宋仲基',
    phoneNumber: '0978901234',
    transactionName: '舞蹈課程扣點',
    transactionPoints: 280,
    remainingPoints: 620,
    updatedTime: 1744157884000,
  },
];
